import { Button, Flex, Typography, UploadFile } from "antd";
import UploadXlsxDragger from "./UploadCsvDragger";
import { useState } from "react";
import handleUploadFile from "../../../../utils/uploadFileS3";
import { BASE_URL } from "../../../../api/emptyV2Api";
import UploadJobTable from "./UploadJobTable";

const ENDPOINT = "usim/inventory/upload?key=input"
const TEMPLATE_FILE_URL = "#"

export default function InventoryUploadPage() {
  // Should only have 0-1 files at any time
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [isUploading, setIsUploading] = useState(false);

  async function handleUpload() {
    setIsUploading(true);
    try {
      setIsUploading(true);
      await handleUploadFile(BASE_URL + ENDPOINT, fileList[0] as unknown as File)
      setTimeout(() => {
        alert("File uploaded successfully. Please refresh to view changes");
        setIsUploading(false);
        window.location.reload();
      }, 2000);
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Failed to upload file. Please try again.");
      setIsUploading(false);
    } finally {
      setFileList([]); // Clear the file list after upload
    }
  }

  function handleDlTemplate() {
    window.open(TEMPLATE_FILE_URL, "_blank");
  }

  return (
    <Flex vertical gap={8}>
      <Typography.Title level={2}>Upload Inventory</Typography.Title>
      <Button type="primary" onClick={handleDlTemplate}>
        Download Template File
      </Button>
      <UploadXlsxDragger fileList={fileList} setFileList={setFileList} />
      <Flex justify="flex-end">
        <Button
          type="primary"
          onClick={handleUpload}
          disabled={fileList.length === 0 || isUploading}
        >
          Upload
        </Button>
      </Flex>
      <UploadJobTable />
    </Flex>
  )
}